// src/utils/settingsService.js
import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../firebase";

// Slides por defecto
export const DEFAULT_SLIDES = [
  { id:"s1", label:"Nuevo", tag:"TENDENCIA", emoji:"\uD83C\uDFE0", accent:"#FF6B6B",
    title:"Decoracion para tu hogar", desc:"Piezas unicas impresas en 3D con amor desde Armenia.", img:"" },
  { id:"s2", label:"Regalos", tag:"ESPECIAL", emoji:"\uD83C\uDF81", accent:"#4DD6D0",
    title:"El regalo perfecto", desc:"Sorprende con algo unico y personalizado.", img:"" },
  { id:"s3", label:"Arte", tag:"ARTESANAL", emoji:"\uD83C\uDFA8", accent:"#FFBA3D",
    title:"Arte en 3D", desc:"Cada pieza es una obra de arte fabricada capa a capa.", img:"" },
];

export async function getStoreSettings() {
  try {
    const snap = await getDoc(doc(db, "settings", "store"));
    return snap.exists() ? snap.data() : {};
  } catch (err) {
    console.error("getStoreSettings:", err);
    return {};
  }
}

export async function saveStoreSettings(data) {
  await setDoc(doc(db, "settings", "store"), data, { merge: true });
}

export async function getSliderSettings() {
  try {
    const snap = await getDoc(doc(db, "settings", "slider"));
    if (snap.exists() && snap.data().slides) return snap.data().slides;
    return DEFAULT_SLIDES;
  } catch (err) {
    console.error("getSliderSettings:", err);
    return DEFAULT_SLIDES;
  }
}

export async function saveSliderSettings(slides) {
  // Limpiar: solo campos primitivos serializables para Firestore
  const cleanSlides = slides.map(slide => ({
    id:     String(slide.id     || ""),
    label:  String(slide.label  || ""),
    tag:    String(slide.tag    || ""),
    emoji:  String(slide.emoji  || ""),
    accent: String(slide.accent || "#FF6B6B"),
    title:  String(slide.title  || ""),
    desc:   String(slide.desc   || ""),
    img:    String(slide.img    || ""),
  }));

  await setDoc(
    doc(db, "settings", "slider"),
    { slides: cleanSlides },
    { merge: false }
  );
}
